import React, { useState } from 'react';
import './HomeFAQs.css';

const HomeFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'Is BooksComply legal for U.S. bookkeeping and tax filing?',
      answer: 'Yes. BooksComply\'s accountants follow IRS-compliant processes and work with CPAs in the U.S.'
    },
    {
      question: 'How long does it take to form a company in the USA?',
      answer: 'Most U.S. company formations are completed within 3–5 business days with our team.'
    },
    {
      question: 'Can I track my project progress with BooksComply?',
      answer: 'Absolutely. Every client gets secure dashboard access to monitor real-time status, updates, and reports.'
    },
    {
      question: 'Can I outsource my U.S. tax returns if I live abroad?',
      answer: 'Absolutely. We help expats and small businesses file taxes remotely with full compliance.'
    }
  ];

  return (
    <section className="home-faq-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Get answers to common questions about our services</p>
        </div>
        
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div className="faq-item" key={index}>
              <button 
                className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                {faq.question}
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </button>
              <div 
                id={`faq-answer-${index}`}
                className={`faq-answer ${activeIndex === index ? 'show' : ''}`}
                aria-hidden={activeIndex !== index}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFAQs;
